import React, { useState } from "react";
import S from "./Image.styled";

import { MainInner, MainSection, motionAnimation } from "@/styles/global";
import { IWPImage, IWPVideo } from "@/src/types";
import { Figcaption } from "@/styles/components";
import Youtube from "@/components/global-components/Youtube";
import { gatsbyImageHelper } from "@/src/helpers";
import { motion } from "framer-motion";

export interface ImageProps {
  blockId: string;
  wpImage: IWPImage;
  imageText?: string;
  textBackground: "fill" | "gradient";
  layout: "horizontal" | "vertical" | "mobileVertical";
  mediaType: "image" | "video";
  video: IWPVideo;
}

const Image: React.FC<ImageProps> = ({
  blockId = "",
  wpImage,
  layout,
  imageText,
  textBackground,
  mediaType,
  video,
}) => {
  const [displayFigCaption, setDisplayFigCaption] = useState(false);
  const imageData = gatsbyImageHelper(wpImage);

  return (
    <S.Section id={blockId} as={motion.section} {...motionAnimation}>
      <MainInner>
        {mediaType === "video" ? (
          <Youtube video={video} />
        ) : (
          <>
            {imageData && (
              <S.ImageWrapper
                $layout={layout}
                onMouseEnter={() => setDisplayFigCaption(true)}
                onMouseLeave={() => setDisplayFigCaption(false)}
              >
                <S.Image image={imageData} alt={wpImage.altText} />
                <Figcaption
                  textBackground={textBackground}
                  imageText={imageText}
                  display={displayFigCaption}
                />
              </S.ImageWrapper>
            )}
          </>
        )}
      </MainInner>
    </S.Section>
  );
};

export default Image;
